import React from 'react';
import styles from './PageHeader.module.css';

export default function PageHeader({
  title,
  description,
  actions,
  breadcrumb,
  className = '',
  children,
}) {
  return (
    <header className={`${styles.pageHeader} ${className}`}>
      {breadcrumb && <div className={styles.breadcrumb}>{breadcrumb}</div>}
      <div className={styles.row}>
        <div className={styles.titleBlock}>
          {title && <h1 className={styles.title}>{title}</h1>}
          {description && <p className={styles.description}>{description}</p>}
        </div>
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
      {children}
    </header>
  );
}
